import { Ability, AbilityBuilder } from '@casl/ability';

import ReportPermissions from '@/pages/reports/ReportPermissions.js';

const { rules, can } = new AbilityBuilder(Ability);

export const ability = new Ability(rules);

/**
 * @param store
 * @returns {*}
 */
export const abilityPlugin = store => {
    return store.subscribe(async mutation => {
        if (mutation.type === 'Auth/LOGOUT') {
            ability.update([]);
        }

        if (!store.getters['Auth/check']) {
            return;
        }

        if (mutation.type === 'Auth/ASSIGN_ROLES_AND_PERMISSIONS') {
            const { permissions } = store.state.Auth;

            permissions.forEach(permission => can(permission.action, permission.subject));

            const reportPermissions = new ReportPermissions(store, can);
            await reportPermissions.register();

            ability.update(rules);
        }
    });
};
